import React from "react";

const Masthead = () => (
  <section className="w-full bg-light-4 py-12 px-6">
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8">
      <div className="flex-1 flex justify-center">
        <img
          src="https://images.unsplash.com/photo-1588072432836-e10032774350?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
          alt="Tuteur avec jeunes"
          className="rounded-2xl shadow-lg w-full max-w-sm md:max-w-md"
        />
      </div>
      <div className="flex-1 text-center md:text-left">
        <h2 className="text-title font-bold text-dark-1 mb-4">
          Transmets ton savoir. Inspire la prochaine génération de Makers.
        </h2>
        <p className="text-normal text-light-1 leading-relaxed">
          Chez <span className="text-blue-1 font-semibold">GoNextMaker</span>, nous croyons que 
          <strong> chaque savoir partagé est une étincelle qui peut changer une vie</strong>.
        </p>
        <p className="text-normal text-dark-3 mt-3">
          Nos tuteurs sont ingénieurs, artistes, enseignants, étudiants, entrepreneurs ou passionnés.  
          Ce qui les unit : l’envie de <strong>partager, guider et apprendre en retour</strong>.
        </p>
      </div>
    </div>
  </section>
);

export default Masthead;
